<template lang="pug">
div
  el-row
    el-col(:span="12")
      app-display(
        label="Nome do Núcleo:",
        :content="imovel.nomeNucleo",
      )
    el-col(:span="12")
      app-display(
        label="Área:",
        :content="formatAreaUnidadeMedida(imovel.area, imovel.unidadeMedidaArea)",
      )
  el-row
    el-col(:span="12")
      app-display(
        label="Número de lotes (aproximadamente):",
        :content="imovel.numeroLotes",
      )
    el-col(:span="12")
      app-display(
        label="Município:",
        :content="imovel.municipio ? imovel.municipio.nome : ''",
      )
</template>
<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import utils from '@/utils/utils'
import InfoMatricula from '@/components/informacoesCadastro/common/InfoMatricula'

export default {
  components: {
    InfoMatricula,
    AppCollapse,
    AppDisplay
  },
  props: {
    imovel: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatAreaUnidadeMedida (area, unidadeMedida) {
      return utils.format(area) + ' ' + this.formataUnidadeMedida(unidadeMedida)
    },
    formataUnidadeMedida (unidade) {
      switch (unidade) {
        case 'ha':
          return 'hectare(s)'
        case 'm2':
          return 'm²'
        default:
          return unidade
      }
    },
    getValue (params) {
      return params || '-'
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/informacoesReurbColetivo/InformacoesReurbColetivoImovel.vue